import { render, staticRenderFns } from "./b-email-btn.vue?vue&type=template&id=1e1a84dd&scoped=true"
import script from "./b-email-btn.vue?vue&type=script&lang=js"
export * from "./b-email-btn.vue?vue&type=script&lang=js"
import style0 from "./b-email-btn.vue?vue&type=style&index=0&id=1e1a84dd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e1a84dd",
  null
  
)

export default component.exports